// extracted by mini-css-extract-plugin
export default {"ClickableText":"ClickableText_ClickableText__l945T"};